import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TArticleDM from './TArticleDM'

export default class TEshopCategoryArticleSummaryDM extends Data {
	public static className = 'TEshopCategoryArticleSummaryDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SubordinateCategory?: string
	IsHideOnShop?: string
	NameForEshop?: string
	IsGroupAssigned?: string
	IsArticleAssigned?: string
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}